import type {UserSessionState} from "./UserSessionState";
import {getFullNameOrEmpty} from "../utils/userHelper";
import {loadScript} from "../utils/script";


export const initSupportChat = async (currentLocale: string, userState: UserSessionState) => {
    window.Tawk_API = window.Tawk_API || {}
    window.Tawk_API.autoStart = true;
    window.Tawk_API.visitor = {
        name: getFullNameOrEmpty(userState.currentUserDb!),
        email: userState.currentUserDb?.email!,
    };
    window.Tawk_LoadStart = new Date();

    if (currentLocale === "ru-RU") {
        await loadScript(import.meta.env.VITE_APP_TWAK_EMBED_RU);
    } else {
        await loadScript(import.meta.env.VITE_APP_TWAK_EMBED);
    }

}
